import React from "react";
import FeatureCard from "./components/FeatureCard";
import "./FeaturesPage.css";

import {
  PageSurface,
  PageWrapper,
} from "../../components/layout/container/Container";
import { PageHeader } from "../../components/layout/header/Header";
import { PageHeading } from "../../components/common/heading/Heading";

import {
  Video,
  User,
  MessageCircle,
  Star,
  Rss,
  Bookmark,
  Scissors,
  Bell,
  CreditCard,
} from "lucide-react";

const FeaturesPage = () => {
  const features = [
    {
      title: "Video Streaming",
      description:
        "Watch live games and catch every replay in HD, anytime, anywhere.",
      icon: <Video size={24} />,
    },
    {
      title: "Talent ID",
      description:
        "Discover and track players’ journeys with detailed profiles and stats.",
      icon: <User size={24} />,
    },
    {
      title: "Messages",
      description:
        "Message and connect with talents, teammates, and coaches securely in real time.",
      icon: <MessageCircle size={24} />,
    },
    {
      title: "Pops",
      description:
        "Quickly highlight and share standout moments with your community.",
      icon: <Star size={24} />,
    },
    {
      title: "Feed",
      description: "Stay updated with personalised highlights, news and posts.",
      icon: <Rss size={24} />,
    },
    {
      title: "Save Items",
      description:
        "Bookmark your favorite clips, profiles and posts to revisit anytime.",
      icon: <Bookmark size={24} />,
    },
    {
      title: "Klip",
      description:
        "Edit and export game clips instantly to create sharable moments.",
      icon: <Scissors size={24} />,
    },
    {
      title: "Notification",
      description:
        "Receive alerts for live games, new content and community activity.",
      icon: <Bell size={24} />,
    },
    {
      title: "Payments",
      description:
        "Subscribe or support your favourite creators safely and easily.",
      icon: <CreditCard size={24} />,
    },
  ];

  return (
    <PageSurface>
      <PageWrapper>
        <PageHeader>
          <PageHeading
            title={"Katch Features"}
            subTitle={
              "Katch continues to evolve, leveraging tools and technology to enhance how we experience sports."
            }
          />
        </PageHeader>

        <br />

        <div className="katch-grid">
          {features.map((f, i) => (
            <FeatureCard key={i} {...f} />
          ))}
        </div>
      </PageWrapper>
    </PageSurface>
  );
};

export default FeaturesPage;
